import { render, staticRenderFns } from "./reviewerDetail.vue?vue&type=template&id=5348c546&scoped=true"
import script from "./reviewerDetail.vue?vue&type=script&lang=js"
export * from "./reviewerDetail.vue?vue&type=script&lang=js"
import style0 from "./reviewerDetail.vue?vue&type=style&index=0&id=5348c546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5348c546",
  null
  
)

export default component.exports